import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import InputItem from './inputItem';

class PersonalInfoForm extends Component {
  constructor(props) {
    super(props);
    this.onDataChange = this.onDataChange.bind(this);
    this.state = { open: false, data: this.props.data }
    this.original = JSON.parse(JSON.stringify(this.props.data))
  }

  onCloseModal = () => {
    this.setState({ data: JSON.parse(JSON.stringify(this.original)), open: false });    
};

  onDataChange(evt) {
    
    const id = evt.target.id
    const val = evt.target.value

    let state = this.state;
    state.data[id] = val;

    if (this.state.openMode === 'pwd') {
      var approvable = (state.data.password === state.data.passwordC);
      approvable = approvable && state.data.password && (state.data.password.length > 0);
      const btn = document.getElementById("approveButton");
      btn.disabled = !approvable;
    }

    this.setState(state);
    
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.data !== this.props.data) {
        this.setState({data: this.props.data});
    }
}

  render() {
    const { data, open, openMode } = this.state;
    
    return (
      <div className="box">
        <div className="box-title">
          <h3>{this.props.title} &nbsp;&nbsp;<button className="badge badge-info " onClick={() => {this.setState({openMode: 'pii', open: true})}}>Edit Info</button>&nbsp;&nbsp;<button className="badge badge-info" onClick={() => {this.setState({openMode: 'pwd', open: true})}}>Change Password</button></h3>
        </div>
        <div className="box-content">
          <h6>Display Name: <span><b>{data.displayname}</b></span></h6>
          <h6>Full Name: <span><b>{`${data.firstname} ${data.lastname}`}</b></span></h6>
          <h6>Phone: <span><b>{data.phone}</b></span></h6>
          <h6>Email: <span><b>{data.email}</b></span> </h6>
          <h6>Password: <span><b>***********</b></span> </h6>

          <Modal open={open} onClose={this.onCloseModal} >
            <div className="modal-header">
              <h5 className="modal-title f-w-600" id="exampleModalLabel2">Update Info</h5>
            </div>
            <div className="modal-body">
              <div className="container">
                <div className="card">
                  <div className="card-body">
                  {openMode === 'pii' 
                  ? <>
                    <InputItem label="Display Name" id="displayname" value={data.displayname} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="First Name" id="firstname" value={data.firstname} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="Last Name" id="lastname" value={data.lastname} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="Phone" id="phone" value={data.phone} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="Email" id="email" value={data.email} onChange={this.onDataChange} placeholder="" />
                    </>
                  : openMode === 'pwd' 
                  ? <>
                    <InputItem label="New Password" id="password" value={data.password} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="Confirm Password" id="passwordC" value={data.passwordC} onChange={this.onDataChange} placeholder="" />
                    </>
                  : null
                  }
                  </div>
                </div>        
              </div>
            </div>
            <div className="modal-footer">              
              <button type="button" className="btn btn-primary" onClick={this.onCloseModal}>Cancel</button>
              <button id="approveButton" type="button" className="btn btn-primary" onClick={() => { this.setState({open: false}); this.props.onCloseModal(openMode, this.state.data)}}>Approve</button>
            </div>
          </Modal>
        </div>
      </div>

      );
  }
}

export default PersonalInfoForm;